import { ServicesPage } from '../features/services'

export default function Services() {
  return <ServicesPage />
}
